import React, { useState } from "react";
import AllMedicines from "./components/AllMedicines";
import BatchScrapeModal from "../../components/batch-scrape/BatchScrapeModal";

function MedicineMaster() {
    const [showBatchScrape, setShowBatchScrape] = useState(false);

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-xl font-semibold text-gray-800">Medicine Master</h1>
                <button
                    onClick={() => setShowBatchScrape(true)}
                    className="px-4 py-2 rounded-lg bg-blue-500 text-white-50 text-sm font-medium hover:bg-blue-600 transition-colors"
                >
                    Batch Scrape
                </button>
            </div>
            <AllMedicines />
            <BatchScrapeModal isOpen={showBatchScrape} onClose={() => setShowBatchScrape(false)} />
        </div>
    );
}

export { MedicineMaster };
